import {
	Card,
	Stack,
	Text,
} from '@chakra-ui/react';

import type { CardRootProps } from '@chakra-ui/react';
import { NextImageWithSkeleton } from '@packages/chakra-v3';

type SimpleCardProps = CardRootProps & {
	image:        string;
	heading:      string;
	description?: string;
};

const SimpleCard = ({
	image, heading, description, ...other
}: SimpleCardProps) => {
	return (
		<Card.Root
			overflow={'hidden'}
			{...other}
		>
			<Card.Body
				display={'flex'}
				flexDir={'column'}
				gap={8}
			>
				<NextImageWithSkeleton
					alt={heading}
					aspectRatio={'wide'}
					borderRadius={8}
					objectFit={'cover'}
					src={image}
					width={'100%'}
				/>
				<Stack gap={0} layerStyle={'black'}>
					<Text textStyle={'h5'}>{heading}</Text>
					<Text textStyle={'p3'}>{description}</Text>
				</Stack>
			</Card.Body>
		</Card.Root>
	);
};

export default SimpleCard;